import { Component, Inject, OnInit} from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-dialog-token-generate',
  templateUrl: './dialog-token-generate.component.html',
  styleUrls: ['./dialog-token-generate.component.sass']
})
export class DialogTokenGenerateComponent implements OnInit {
  model: any = {
    role: 'PROGRAM_M2M',
    comment: ''
  };
  roles = [
    'PROGRAM_M2M',
    'CONNECTOR',
    'INJECTOR'
  ];

  constructor(
    public dialogRef: MatDialogRef<DialogTokenGenerateComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  ngOnInit() {}

  onConfirm() {
    this.dialogRef.close(this.model);
  }

  onCancel() {
    this.dialogRef.close(false);
  }
}
